/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import TenantIntegrationEndpointAttribute from './tenant-integration-endpoint-attribute';
import TenantIntegrationEndpointAttributeDetail from './tenant-integration-endpoint-attribute-detail';
import TenantIntegrationEndpointAttributeUpdate from './tenant-integration-endpoint-attribute-update';
import TenantIntegrationEndpointAttributeDeleteDialog from './tenant-integration-endpoint-attribute-delete-dialog';

const TenantIntegrationEndpointAttributeRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<TenantIntegrationEndpointAttribute />} />
    <Route path="new" element={<TenantIntegrationEndpointAttributeUpdate />} />
    <Route path=":id">
      <Route index element={<TenantIntegrationEndpointAttributeDetail />} />
      <Route path="edit" element={<TenantIntegrationEndpointAttributeUpdate />} />
      <Route path="delete" element={<TenantIntegrationEndpointAttributeDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default TenantIntegrationEndpointAttributeRoutes;
